export default class {
    constructor (FileResource, Upload, ResponseService, $q) {
        this.FileResource = FileResource;
        this.Upload = Upload;
        this.ResponseService = ResponseService;
        this.$q = $q;
        this.apiUrl = `${SEED_CORE.ENV.API_URL}file/file`;
    }
    upload (file, attachToEntities) {
        const data = { file };
        if (attachToEntities && attachToEntities.length) {
            data.attachToEntities = JSON.stringify(attachToEntities);
        }
        return this.Upload.upload({
            url: `${this.apiUrl}/upload`,
            data
        });
    }
    attach (fileHash, entityType, entityId) {
        return this.FileResource.attach({ fileHash, entityType, entityId }).$promise;
    }
    detach (fileHash, entityType, entityId) {
        return this.FileResource.detach({ fileHash, entityType, entityId }).$promise;
    }
    deleteFile (fileHash, detachFromEntities) {
        const payload = {};
        if (detachFromEntities && detachFromEntities.length) {
            payload.detachFromEntities = detachFromEntities;
        }
        return this.FileResource.deleteFile({ hash: fileHash }, payload).$promise;
    }
    getEntityFiles (entityType, entityId) {
        return this.FileResource.entityFiles({
            entityType,
            entityId
        }).$promise;
    }
    listFiles (entityType, entityId) {
        const params = {};
        if (entityType) {
            params.entityType = entityType;
        }
        if (entityId) {
            params.entityId = entityId;
        }
        return this.FileResource.list(params).$promise;
    }
    getDownloadUrl (fileHash) {
        return `${this.apiUrl}/${fileHash}`;
    }
}



// WEBPACK FOOTER //
// ./src/app/services/file/index.js